<div class="content-block content-block-confirmation has-padding">
  <img [class.hidden]="federationIsNotReady$ | async" class="illustration" src="{{ assetsPath }}/assets/images/content/new-account-confirm.png" alt="">

  @if (federationIsNotReady$ | async) {
    <div class="mb-4">
      <loader-spinner size="normal"/>
    </div>
  }

  @if ((federationIsNotReady$ | async) === false && (federationFormError$ | async) === false) {
    <h1 data-cy="TitleNewFederationValidation" translate="PageTitles.NewFederationValidation"></h1>
  }

  <div class="row justify-content-center">
    @if (federationIsNotReady$ | async) {
      <p class="text-left" innerHTML="{{ 'Federation.Validation.CreationText' | translate }}"></p>
    }
    @if ((federationIsNotReady$ | async) === false && (federationFormError$ | async) === false) {
      <p class="text-left" innerHTML="{{ 'Federation.Validation.ConfirmationText' | translate }}"></p>
    }
  </div>

  @if ((federationIsNotReady$ | async) === false && (federationFormError$ | async) === false) {
    <div class="mt-4">
      @if (selectedFederation$ | async; as selectedFederation) {
        <a target="_blank" data-cy="OpenTabFederationDetailUsers" [routerLink]="federationDetailUsersPath(selectedFederation.federationId)" routerLinkActive="active" class="btn btn-primary">
          {{ 'NewAccount.Validation.InviteUsers' | translate }}
        </a>
        <button (click)="goToFederation(selectedFederation.federationId)" class="btn btn-primary ml-4">
          {{ 'Federation.Validation.Button' | translate }}
        </button>
      }
    </div>
  }

  @if ((federationFormError$ | async)) {
    <div>
      {{ 'NewAccount.Validation.Error' | translate }}
    </div>
  }
</div>
